/* EVENTS */
export const GET_PROFILE = "GET_PROFILE"
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL"

export const UPDATE_PROFILE = "UPDATE_PROFILE"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL"

export const UPDATE_PROFILEPW = "UPDATE_PROFILEPW"
export const UPDATE_PROFILEPW_SUCCESS = "UPDATE_PROFILEPW_SUCCESS"
export const UPDATE_PROFILEPW_FAIL = "UPDATE_PROFILEPW_FAIL"

export const RESET_PROFILE_STATE = 'RESET_PROFILE_STATE';
